export { ExpandedContainer } from './ExpandedContainer';
export type { ExpandedContainerProps } from './ExpandedContainer';
